import {
  Container,
  MenuItem,
  SvgIcon,
  Grid,
  Paper,
  TablePagination,
  Divider,
  Select
} from "@mui/material";
import { KeyboardBackspace, KeyboardArrowLeft, KeyboardArrowRight, SettingsPowerTwoTone } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import * as React from 'react';
import { useCallback } from 'react';
import { ReactComponent as CalendarIcon } from "../../assets/ico_calendar.svg";
import Autocomplete from '@mui/material/Autocomplete';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
import { IUserDetails, ITotalUsers, ITotalUsersIncrease, ITotalRevenue, RevenueIncreasePercentage, TotalGoogleVisit, TotalGoogleIncreasePercentage, TotalUsers, TotalRevenueSum ,Deletesubscriber, ISubscriberDetails, GetSubscribers } from "../../redux/api/types";
import { useGetTotalUsersQuery, useGetTotalUsersIncreaseQuery, useGetTotalRevenueQuery, useGetRevenueIncreasePercentageQuery, useGetTotalGoogleVisitQuery, useGetTotalGoogleIncreasePercentageQuery, useGetTotalCountUsersQuery, useGetTotalRevenueSumQuery , } from "../../redux/api/paymentApi";
import { useActiveUserMutation, useDeactiveUserMutation, useUsersListMutation ,useDeleteSubscriberMutation ,useGetSubscribersMutation } from "../../redux/api/authApi";
import { isBrowser, isMobile, MobileView, BrowserView } from "react-device-detect";
import { useState, useEffect } from "react";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { IProductHeadings } from "../../redux/api/types";
import { useLazySearchProductQuery } from "../../redux/api/productApi";
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import { ToastContainer, toast } from "react-toastify";
import { AutocompleteChangeReason, AutocompleteChangeDetails } from '@mui/material/Autocomplete';
import {
  startOfDay,
  endOfDay,
  subDays,
  subMonths,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
} from 'date-fns';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from '@mui/icons-material/Delete';


const SubscribeList = () => {
  const customInputStyle = {
    color: 'Black',
    border: '1px solid #CBCBCB',
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      // backgroundColor: '#1377C3', 
      color: 'lightblack',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: 'white', // Set background color for odd rows to white
      color: 'black', // Set text color for odd rows to black
    },
    '&:nth-of-type(even)': {
      backgroundColor: '#F2F6FA', // Set background color for even rows to gray
      color: 'darkslategray',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const StyledButton = styled(IconButton)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
  }));
  const StyledDay = styled(PickersDay)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.primary.dark
        : theme.palette.primary.light,
  }));


  const [userlists, setuserlists] = useState<GetSubscribers[] | undefined>(undefined);
  const [subscriberlists, setsubscriberlists] = useState<GetSubscribers[] | undefined>(undefined);
  const [userRecords, setUserRecords] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const pageSize = isMobile ? 5 : 10;
  const [pageSize, setPageSize] = useState(isMobile ? 5 : 10);
  const [searchText, setSearchText] = useState('');

  const [selectedRange, setSelectedRange] = useState<string>('thisWeek');
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: '',
    endDate: '',
  });

  const [selectedPrevRange, setSelectedPrevRange] = useState('previous_week');

  const [UsersListMutation] = useUsersListMutation();
  console.log(UsersListMutation);

  const [subscribersListMutation] = useGetSubscribersMutation();
  console.log(subscribersListMutation);



  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [customerFromDate, setCustomerFromDate] = useState('');
  const [customerToDate, setCustomerToDate] = useState('');
  const [options, setOptions] = useState<IProductHeadings[]>([]);
  const [searchProduct, searchState] = useLazySearchProductQuery();
  const [filter, setFilter] = useState<IProductHeadings | null>(null);


  useEffect(() => {
    searchProduct("");
  }, []);


  const handlePrevRangeChange = (event: React.ChangeEvent<{ value: string }>) => {
    const newMode: string = event.target.value;
    setSelectedPrevRange(newMode);
  }

  const [productVal, setproductVal] = useState('');
  const [totalusers, setTotalUsers] = useState<ITotalUsers | undefined>(undefined);
  const [totalusersincrease, setTotalUsersIncrease] = useState<ITotalUsersIncrease | undefined>(undefined);
  const [totalRevenue, setTotalRevenue] = useState<ITotalRevenue | undefined>(undefined);
  const [totalCountusers, setTotalCountUsers] = useState<TotalUsers | undefined>(undefined);
  const [totalRevenueSum, setTotalRevenueSum,] = useState<TotalRevenueSum | undefined>(undefined);
  const [revenueincreasepercentage, setRevenueIncreasePercentage] = useState<RevenueIncreasePercentage | undefined>(undefined);
  const [totalgooglevisit, setTotalGoogleVisit] = useState<TotalGoogleVisit | undefined>(undefined);
  const [totalgoogleincreasepercentage, setTotalGoogleIncreasePercentage] = useState<TotalGoogleIncreasePercentage | undefined>(undefined);

  const { data, isSuccess, isError } = useGetTotalUsersQuery({ from_date: /* '2023-10-27' */fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: /* '2023-11-02' */toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });
  const userincreasedata = useGetTotalUsersIncreaseQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });
  const revenuedata = useGetTotalRevenueQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });
  const totalUsersCount = useGetTotalCountUsersQuery({});
  const totalRevenueSumCount = useGetTotalRevenueSumQuery({});
  const revenueincreasedata = useGetRevenueIncreasePercentageQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });
  const totalgoogledata = useGetTotalGoogleVisitQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });
  const totalgooglepercentagedata = useGetTotalGoogleIncreasePercentageQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate, mode: selectedPrevRange, product: productVal });


  useEffect(() => {
    if (searchState.data) {
      setOptions(searchState.data);
    }
  }, [searchState]);

  useEffect(() => {
    const formattedDateRange = getDateRange(selectedRange);
    setDateRange(formattedDateRange);
    console.log(formattedDateRange.startDate);
    console.log(formattedDateRange.endDate);
  }, [selectedRange]);

  const handleRangeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newRange = event.target.value as string;
    setSelectedRange(newRange);
  }


  function getDateRange(range: string): { startDate: string; endDate: string } {
    const currentDate = new Date();
    let startDate: Date;
    let endDate: Date;

    switch (range) {
      case 'today':
        startDate = startOfDay(currentDate);
        endDate = endOfDay(currentDate);
        break;
      case 'yesterday':
        const yesterday = subDays(currentDate, 1);
        startDate = startOfDay(yesterday);
        endDate = endOfDay(yesterday);
        break;
      case 'last7Days':
        const last7DaysStartDate = subDays(currentDate, 7);
        startDate = startOfDay(last7DaysStartDate);
        endDate = endOfDay(currentDate);
        break;
      case 'last30Days':
        const last30DaysStartDate = subDays(currentDate, 30);
        startDate = startOfDay(last30DaysStartDate);
        endDate = endOfDay(currentDate);
        break;
      case 'thisMonth':
        startDate = startOfMonth(currentDate);
        endDate = endOfMonth(currentDate);
        break;
      case 'lastMonth':
        const lastMonthStartDate = startOfMonth(subMonths(currentDate, 1));
        const lastMonthEndDate = endOfMonth(subMonths(currentDate, 1));
        startDate = lastMonthStartDate;
        endDate = lastMonthEndDate;
        break;
      case 'thisWeek':
        const thisWeekStartDate = startOfWeek(currentDate);
        const thisWeekEndDate = endOfWeek(currentDate);
        startDate = thisWeekStartDate;
        endDate = thisWeekEndDate;
        break;
      default:
        startDate = new Date(); // You can provide a default value here
        endDate = new Date(); // You can provide a default value here
        break;
    }

    const formattedStartDate = format(startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(endDate, 'yyyy-MM-dd');

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  }




  const handleFromDateChange = (date: any) => {
    console.log(date);
    setFromDate(date);
  };

  const handleToDateChange = (date: any) => {
    console.log(date);
    setToDate(date);
  };


  const handlecustoFromDate = (date: any) => {
    setCustomerFromDate(date);
  }

  const handlecustoToDate = (date: any) => {
    setCustomerToDate(date);
  }

  const handleProductChange = (
    event: React.ChangeEvent<{}>,
    value: IProductHeadings | null,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<{}> | undefined
  ) => {
    if (value) {
      // Assuming IProductHeadings has a property like 'product_module'
      setproductVal(value.product_module);
    } else {
      // Handle the case where value is null
      setproductVal('');
    }
  };

  useEffect(() => {
    console.log(userlists);
    console.log(userRecords);
    setTotalUsers(data as ITotalUsers | undefined);
    setTotalUsersIncrease(userincreasedata.data as ITotalUsersIncrease | undefined);
    setTotalRevenue(revenuedata.data as ITotalRevenue | undefined);
    setTotalCountUsers(totalUsersCount.data as TotalUsers | undefined);
    setTotalRevenueSum(totalRevenueSumCount.data as TotalRevenueSum | undefined);
    setRevenueIncreasePercentage(revenueincreasedata.data as RevenueIncreasePercentage | undefined);
    setTotalGoogleVisit(totalgoogledata.data as TotalGoogleVisit | undefined);
    setTotalGoogleIncreasePercentage(totalgooglepercentagedata.data as TotalGoogleIncreasePercentage | undefined);
  }, [userlists, userRecords, data, userincreasedata, revenuedata, revenueincreasedata, totalgoogledata, totalgooglepercentagedata])


  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response: any = await subscribersListMutation({
          skip: (currentPage - 1) * pageSize,
          limit: pageSize,
          from_date: customerFromDate ? format(new Date(customerFromDate), 'yyyy-MM-dd') : '',
          to_date: customerToDate ? format(new Date(customerToDate), 'yyyy-MM-dd') : '',
          search_str: searchText
        });
        const userValues = response.data.userdet;
        setuserlists(userValues);

        const userRec = response.data;
        setUserRecords(userRec.totalrecords);

      } catch (error) {
        console.error('Error generating blog:', error);

      }
    }
    fetchdata();
  }, [currentPage, pageSize, customerFromDate, customerToDate, searchText])


  

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  /*commented by sara*/
  // useEffect(() => {
  //   if (userlists) {
  //     const userhistory = userlists.map((users, index) => ({
  //       ...users,
  //       serialNumber: (currentPage - 1) * pageSize + index + 1,
  //     }));
  //     setuserlists(userhistory);
  //   }
  // }, [userlists]);
  /*commented by sara*/


  // Pagination
  let totalPages = Math.ceil(parseInt(userRecords) / pageSize);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  }

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
  }

  const generatePageNumbers = (totalPages: number, currentPage: number): (number | '...')[] => {
    const pageNumbers: (number | '...')[] = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || Math.abs(i - currentPage) < 3) {
        pageNumbers.push(i);
      } else if (pageNumbers[pageNumbers.length - 1] !== '...') {
        pageNumbers.push('...');
      }
    }
    return pageNumbers;
  };

  const pageNumbers = generatePageNumbers(totalPages, currentPage);
  //


  // Filter the userlists based on the searchText
  /* const filteredUsers = userlists ? userlists.filter(user => {
    const search = searchText.toLowerCase();
    return user.name.toLowerCase().includes(search) ||
      user.email.toLowerCase().includes(search) ||
      user.initial_product.toLowerCase().includes(search);
  }) : []; */

  

  


  const [DeleteSubscriberMutation] = useDeleteSubscriberMutation();

  const handleDeleteSubscriberUser = useCallback(async (email: string, iindex: number, uuserlist: ISubscriberDetails[]) => {
    try {
      const isConfirmed = window.confirm('Are you sure you want to delete this user?');
      // If the user confirms, proceed with activation
      if (isConfirmed) {
        const response = await DeleteSubscriberMutation({ email });
        if ('data' in response) {
          const data = response.data;
          if (data.status === 'success') {
            toast.success('Deleted successfully');
            // After successful activation, update userlists
            const updatedUserList = uuserlist.map((user, index) =>  
              index === iindex ? { ...user, status: 'active' } : user
            );
            
            window.location.reload();
          } else {
            toast.error('Failed to delete the user');
          }
        } else {
          toast.error('Failed to delete the user');
        }
      }
    } catch (error) {
      console.error('Error deleting user', error);
      toast.error('An error occurred while deleting the user');
    }
  }, [DeleteSubscriberMutation]);
  


  return (
    <>

      <div className="body-17">
        <Container sx={{ paddingTop: 5 }} maxWidth="lg">
          <Typography style={{ color: 'black' }} variant="h5">Subscriber List</Typography>

          <Stack sx={{
            // gap: 7,

            '@media (min-width: 600px)': {
              // Adjust gap for screens with a minimum width of 600px (sm)
              flexDirection: "column"
            },
            '@media (min-width: 960px)': {
              // Adjust gap for screens with a minimum width of 960px (md)
              flexDirection: "row"
            },
            '@media (min-width: 1280px)': {
              // Adjust gap for screens with a minimum width of 1280px (lg)
              flexDirection: "row"
            },
          }}>
            <Box style={{ width: '100%' }}>
              <Box padding={1} style={{ width: '100%' }}>
                <Stack sx={{
                  // gap: 7,

                  '@media (min-width: 600px)': {
                    // Adjust gap for screens with a minimum width of 600px (sm)
                    flexDirection: "column"
                  },
                  '@media (min-width: 960px)': {
                    // Adjust gap for screens with a minimum width of 960px (md)
                    flexDirection: "row"
                  },
                  '@media (min-width: 1280px)': {
                    // Adjust gap for screens with a minimum width of 1280px (lg)
                    flexDirection: "row",
                    display: 'flex', justifyContent: 'space-between'
                  },
                }}>
                  <Box sx={{

                    '@media (min-width: 600px)': {
                      flexDirection: 'column', // Adjust direction for screens with a minimum width of 600px (sm)
                    },
                    '@media (min-width: 960px)': {
                      flexDirection: 'row', // Adjust direction for screens with a minimum width of 960px (md)
                    },
                    '@media (min-width: 1280px)': {
                      flexDirection: 'row', // Adjust direction for screens with a minimum width of 1280px (lg)
                      display: 'flex',
                      justifyContent: 'space-between',
                    },
                  }}>
                    {/* <TextField style={{ width: '100%' }} select defaultValue="last_seven" size="small"
                      InputProps={{
                        className: 'red-border',
                        style: customInputStyle,
                        endAdornment: (
                          <ArrowDropDownIcon /> // Add the dropdown icon here
                        ),// Apply the CSS class to set the border color to red
                      }}>

                      <MenuItem value="last_seven">Pick a date range</MenuItem>

                    </TextField> */}
                    <Stack padding={1}
                      sx={{
                        // gap: 7,

                        '@media (min-width: 600px)': {
                          // Adjust gap for screens with a minimum width of 600px (sm)
                          flexDirection: "column",

                        },
                        '@media (min-width: 960px)': {
                          // Adjust gap for screens with a minimum width of 960px (md)
                          flexDirection: "row",
                          display: 'flex',
                          justifyContent: 'space-between'
                        },
                        '@media (min-width: 1280px)': {
                          // Adjust gap for screens with a minimum width of 1280px (lg)
                          flexDirection: "row",
                          display: 'flex',
                          justifyContent: 'space-between'
                        },
                      }} >
                      <Box className="year"
                        sx={{
                          display: 'grid',
                          gap: '10px',
                          '@media (min-width: 600px)': {
                            display: 'grid', // Apply this style for screens with a minimum width of 600px (sm)
                            gap: '10px',
                          },
                          '@media (min-width: 960px)': {
                            display: 'flex', // Apply this style for screens with a minimum width of 960px (md)
                            gap: '10px',
                          },
                        }} >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box
                            sx={{
                              display: 'grid',
                              gap: '10px',
                              '@media (min-width: 600px)': {
                                display: 'grid', // Apply this style for screens with a minimum width of 600px (sm)
                                gap: '10px',
                              },
                              '@media (min-width: 960px)': {
                                display: 'flex', // Apply this style for screens with a minimum width of 960px (md)
                                gap: '10px',
                              },
                            }}
                          >
                            <DemoItem>
                              <DatePicker
                                sx={{ width: isMobile ? '100%' : '230px' }}
                                slotProps={{
                                  openPickerIcon: { fontSize: 'small' },
                                  openPickerButton: { color: 'primary' },
                                  leftArrowIcon: { color: 'primary' },
                                  rightArrowIcon: { color: 'primary' },
                                  textField: {
                                    variant: 'filled',
                                    focused: true,
                                    color: 'primary',
                                  },
                                }}
                                value={customerFromDate}
                                onChange={handlecustoFromDate}
                              />
                            </DemoItem>

                          </Box>
                        </LocalizationProvider>
                      </Box>
                    </Stack>

                    <Stack padding={1}
                      sx={{
                        // gap: 7,

                        '@media (min-width: 600px)': {
                          // Adjust gap for screens with a minimum width of 600px (sm)
                          flexDirection: "column",

                        },
                        '@media (min-width: 960px)': {
                          // Adjust gap for screens with a minimum width of 960px (md)
                          flexDirection: "row",
                          display: 'flex',
                          justifyContent: 'space-between'
                        },
                        '@media (min-width: 1280px)': {
                          // Adjust gap for screens with a minimum width of 1280px (lg)
                          flexDirection: "row",
                          display: 'flex',
                          justifyContent: 'space-between'
                        },
                      }} >
                      <Box className="year"
                        sx={{
                          display: 'grid',
                          gap: '10px',
                          '@media (min-width: 600px)': {
                            display: 'grid', // Apply this style for screens with a minimum width of 600px (sm)
                            gap: '10px',
                          },
                          '@media (min-width: 960px)': {
                            display: 'flex', // Apply this style for screens with a minimum width of 960px (md)
                            gap: '10px',
                          },
                        }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box
                            sx={{
                              display: 'grid',
                              gap: '10px',
                              '@media (min-width: 600px)': {
                                display: 'grid', // Apply this style for screens with a minimum width of 600px (sm)
                                gap: '10px',
                              },
                              '@media (min-width: 960px)': {
                                display: 'flex', // Apply this style for screens with a minimum width of 960px (md)
                                gap: '10px',
                              },
                            }}
                          >
                            <DemoItem>
                              <DatePicker
                                sx={{ width: isMobile ? '100%' : '230px' }}
                                slotProps={{
                                  openPickerIcon: { fontSize: 'small' },
                                  openPickerButton: { color: 'primary' },
                                  leftArrowIcon: { color: 'primary' },
                                  rightArrowIcon: { color: 'primary' },
                                  textField: {
                                    variant: 'filled',
                                    focused: true,
                                    color: 'primary',
                                  },
                                }}
                                value={customerToDate}
                                onChange={handlecustoToDate}
                              />
                            </DemoItem>

                          </Box>
                        </LocalizationProvider>
                      </Box>
                    </Stack>
                    &nbsp;

                    <TextField
                      style={{ border: '1px solid #CBCBCB', borderRadius: '5px', width: '100%', marginTop: '0%', height: '80%' }}
                      placeholder="Search by name"
                      size="small"
                      /*  InputLabelProps={{
                         className: 'red-label',
                         style: { height: '110%' }
                       }} */
                      // onChange={(e) => setSearchText(e.target.value)}
                      value={searchText}
                      onChange={handleInputChange}

                    />
                  </Box>&nbsp;
                  <Box sx={{

                    '@media (min-width: 600px)': {
                      flexDirection: 'column', // Adjust direction for screens with a minimum width of 600px (sm)
                    },
                    '@media (min-width: 960px)': {
                      flexDirection: 'row', // Adjust direction for screens with a minimum width of 960px (md)
                    },
                    '@media (min-width: 1280px)': {
                      flexDirection: 'row', // Adjust direction for screens with a minimum width of 1280px (lg)
                      display: 'flex',
                      justifyContent: 'space-between',
                    },
                  }}>
                    <MenuItem value="last_seven" >
                      Shown by
                    </MenuItem>
                    <TextField style={{ width: '100%', justifyContent: 'center' }} select defaultValue="last_seven" size="small"
                      InputProps={{
                        className: 'red-border',
                        style: customInputStyle,
                        endAdornment: (
                          <ArrowDropDownIcon />
                        ),
                      }}
                      value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>

                      <MenuItem value="10">10</MenuItem>
                      <MenuItem value="25">25</MenuItem>
                      <MenuItem value="50">50</MenuItem>
                    </TextField>
                    &nbsp;

                  </Box>

                </Stack>
              </Box>
            </Box>
          </Stack>





          {isBrowser ?
            <TableContainer component={Paper} sx={{ margin: '1%', width: '100%' }}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead style={{ backgroundColor: ' #F2F6FA', border: "gray" }}>
                  <TableRow>
                    <StyledTableCell style={{ border: "gray" }} align="center">S.No </StyledTableCell>
                    <StyledTableCell style={{ border: "gray" }} align="center">EMAIL</StyledTableCell>
                    <StyledTableCell style={{ border: "gray" }} align="center">REGISTRATION DATE</StyledTableCell>
                    <StyledTableCell style={{ border: "gray" }} align="center">STATUS</StyledTableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {filteredUsers ? filteredUsers.map((user, index) => ( */}
                  {userlists ? userlists.map((user, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell style={{ color: 'black', border: "darkgray" }} align="left">{index + 1 + (currentPage - 1) * 10}</StyledTableCell>
                      <StyledTableCell style={{ color: 'black', border: "darkgray" }} align="left">{user.email}</StyledTableCell>
                      <StyledTableCell style={{ color: 'black', border: "darkgray" }} align="left">{user.create_at.split("T")[0]}</StyledTableCell>
                      <StyledTableCell align="center" style={{ cursor: 'pointer', border: "darkgray" }}>{user.status ? (user.status === 'inactive' ? <Tooltip title="Activate user"><SvgIcon style={{ color: 'red' }} component={DeleteIcon}   onClick={() => handleDeleteSubscriberUser(user.email, index, userlists)}>{'Activate'} </SvgIcon></Tooltip> : <Tooltip title="Delete user"><SvgIcon aria-label="Deactivate user" style={{ color: "red" }} component={DeleteIcon} inheritViewBox onClick={() => handleDeleteSubscriberUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>) : <Tooltip title="Delete user"><SvgIcon aria-label="Delete user" style={{ color: "red" }} component={DeleteIcon} inheritViewBox onClick={() => handleDeleteSubscriberUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>}</StyledTableCell>

                    </StyledTableRow>
                  )) : null}
                </TableBody>
              </Table>
            </TableContainer> :
            <Box style={{ backgroundColor: '#F9FBFC', height: '100%', padding: '1%', borderRadius: '5px' }}>
              {userlists ? userlists.map((user, index) => (
                <Stack>
                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>S.No:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}>{index + 1 + (currentPage - 1) * 5}</Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Phone:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}></Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Email:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}>{user.email}</Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Product:</Typography>
                    </Grid>
                  </Grid>
                  
                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Registration Date:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}>{user.create_at.split("T")[0]}**</Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Last Login:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}></Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>IP:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}></Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Status:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400}>{user.status ? user.status : 'subscriber'}</Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={900}>Action:</Typography>
                    </Grid>
                    <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                      <Typography color="#000"
                        variant="h6"
                        fontWeight={400} style={{ cursor: 'pointer' }}>{user.status === 'active' ? <Button variant="contained" style={{ backgroundColor: 'red', height: '25px' }}>{'Deactivate'}</Button> : <Button variant="contained" style={{ backgroundColor: '#59E659', height: '25px' }}>{'Activate'}</Button>}</Typography>
                    </Grid>
                  </Grid>
                  <Divider style={{ margin: '1%' }} />
                </Stack>
              )) : <Stack>
                <Grid container>
                  <Grid item xs={12} md={12} lg={12} style={{ padding: '1%' }}>
                    <Typography color="#000"
                      variant="h6"
                      fontWeight={400}>No users Available</Typography>
                  </Grid>
                </Grid>
              </Stack>}
            </Box>
          }



          <div style={{ textAlign: 'center' }}>
            <LoadingButton
              startIcon={
                <SvgIcon>
                  <KeyboardArrowLeft />
                </SvgIcon>
              }

              sx={{
                paddingRight: '15px'
              }}
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >

            </LoadingButton>

            {/* <span>{currentPage}</span> */}
            {pageNumbers.map((page, index) => (
              <span key={index} style={{ padding: '0 5px' }}>
                <span
                  style={{
                    cursor: page === '...' ? 'default' : 'pointer',
                    fontWeight: page === currentPage ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (typeof page === 'number') setCurrentPage(page);
                  }}
                >
                  {page}
                </span>
              </span>
            ))}

            <LoadingButton
              startIcon={
                <SvgIcon>
                  <KeyboardArrowRight />
                </SvgIcon>
              }

              sx={{
                paddingLeft: '35px'
              }}
              onClick={handleNextPage}
              disabled={userlists && userlists?.length < pageSize}
            >

            </LoadingButton>
          </div>
        </Container>

        <Container>&nbsp;</Container>
        <Container>&nbsp;</Container>
        <Container>&nbsp;</Container>
        <Container>&nbsp;</Container>
        <Container>&nbsp;</Container>

      </div>


    </>
  );
};

export default SubscribeList;
